import classNames from 'classnames';

const Split = ({ className = '', children }) => (
    <div className={classNames('d-flex justify-content-between', className)}>{children}</div>
);
export default Split;
